import Service from "@/helpers/py-service";

const state = {
  loading: false,
  meta: {},
  list: [],
  //
};

const mutations = {
  SET_LIST(state, payload) {
    state.list = payload;
  },
};

const actions = {
  list: (store, params) => {
    store.state.loading = true;
    return Service.get("charging-station/session-heatmap", params)
      .then((data) => {
        store.commit("SET_LIST", data.body);
        return data.body;
      })
      .finally(() => (store.state.loading = false));
  },
};

const getters = {
  getLoading(state) {
    return state.loading;
  },
  getMeta(state) {
    return state.meta;
  },
  getList(state) {
    return state.list;
  },
};

const dataCompleteness = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default dataCompleteness;
